import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import androidx.compose.runtime.*
import androidx.compose.material.Text
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import link.erpango.quip.AppScreen
import link.erpango.quip.AppSharedFactory
import link.erpango.quip.core.SharedFactory
import link.erpango.quip.data.JsSessionStorage
import link.erpango.quip.platform.TokenRefreshScheduler
import kotlinx.browser.document
import kotlinx.coroutines.Dispatchers

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    ComposeViewport(document.body!!) {
        var sharedFactory by remember { mutableStateOf<SharedFactory?>(null) }
        
        LaunchedEffect(Unit) {
            val factory = AppSharedFactory().create()
            
            // Initialize platform utilities
            val platformManager = link.erpango.quip.utils.JsPlatformManager()
            link.erpango.quip.utils.PlatformUtils.create(platformManager)
            
            val fileUtils = link.erpango.quip.utils.JsFileUtils()
            link.erpango.quip.utils.FileUtils.create(fileUtils)

            val calendarUtils = link.erpango.quip.utils.JsCalendarUtils()
            link.erpango.quip.utils.CalendarUtils.create(calendarUtils)
            
            val notifications = link.erpango.quip.platform.services.NotificationService()
            val googleAuthProvider = link.erpango.quip.core.auth.google.GoogleAuthProviderImpl()
            
            link.erpango.quip.Quip.appComponents = link.erpango.quip.AppComponents(
                factory = factory,
                notifications = notifications,
                googleAuthProvider = googleAuthProvider
            )
            TokenRefreshScheduler.start(factory)
            sharedFactory = factory
        }

        // Observe auth changes and mirror to localStorage
        val currentFactory = sharedFactory
        if (currentFactory != null) {
            val authViewModel = currentFactory.auth.createAuthViewModel()
            
            LaunchedEffect(currentFactory) {
                authViewModel.authFlow.collect { auth ->
                    if (auth != null) {
                        JsSessionStorage.saveSession(auth)
                    } else {
                        if (JsSessionStorage.hasSession()) {
                            JsSessionStorage.clearSession()
                        }
                    }
                }
            }

            AppScreen(currentFactory)
        } else {
            Box(modifier = Modifier.fillMaxSize(), contentAlignment = Alignment.Center) {
                Text("Loading Quip...")
            }
        }
    }
}

